import React, { useRef } from 'react';
import { useIntersection } from '../hooks/useScrolled';
//import collections6 from '../images/goldAdvance.jpg';
import './GoldAdvanceBooking.css';

export default function GoldAdvanceBooking() {
  const ref = useRef(null);
  const visible = useIntersection(ref);

  return (
    <section className="gold-advance" id="gold-plans" ref={ref}>

      {/* ── Parallax Hero Banner ── */}
      <div className="gold-advance__parallax">
        <div className="gold-advance__parallax-overlay" />
        <div className={`gold-advance__hero-content${visible ? ' visible' : ''}`}>
          <p className="gold-advance__hero-tagline">Every <em>jewel</em> tells a story</p>
          <h1 className="gold-advance__hero-heading">which one will <span>you choose</span>&nbsp;?</h1>
        </div>
       
      </div>

      {/* ── Main content card ── */}
      {/* <div className={`gold-advance__inner${visible ? ' visible' : ''}`}> */}

        {/* Left: Text content */}
        {/* <div className="gold-advance__content">
          <span className="gold-advance__label">Gold Advance Booking</span>
          <h2 className="gold-advance__title">
            By paying <span className="gold-advance__highlight">30%</span> onwards
          </h2>
          <p className="gold-advance__desc">
            Secure your gold price today! Start with just 30% and shield yourself from rising gold
            rates for upto 6 months.
          </p>
          <a href="#contact" className="gold-advance__cta">
            Call Back
          </a>
        </div> */}

        {/* Right: Jewellery image */}
        {/* <div className="gold-advance__img-wrap">
          <img
            src={collections6}
            alt="Gold ornament jewellery"
            className="gold-advance__img"
          />
          <div className="gold-advance__img-shine" />
        </div>
      </div> */}

      {/* ── Callback banner ── */}
      <div className="gold-advance__callback">
        <div className="gold-advance__callback-inner">
          <div className="gold-advance__callback-text">
            <p className="gold-advance__callback-quote">
              JKS Jewels VISION is to continue the rich heritage by maintaining
              the focus on plain &amp; studded gold jewellery and articles while widening
              distribution through contemporary and accessible price points in order to take
              the brand internationally. JKS Jewels MISSION is Customers Satisfaction.
            </p>
          </div>
           
        </div>
      
      </div>

    </section>
  );
}
